module.exports = __webpack_public_path__ + "static/media/right-slide.224e0e4f.svg";